<!--密码-->
<template>
  <el-input
    v-model="value"
    v-bind="$attrs"
    :id="'c' + formItemMeta.columnId"
    :name="'c' + formItemMeta.columnId"
    :title="title"
    :clearable="clearable"
    show-password
  >
  </el-input>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  // import { ElInput } from 'element-plus'
  // 引入组件需要的属性 引入表单子控件的管理类
  import { itemProps, itemController } from '../map'

  export default defineComponent({
    name: 'nf-el-form-item-password',
    inheritAttrs: false,
    components: {
      // ElInput
    },
    props: {
      modelValue: [String],
      'show-password': {
        type: Boolean,
        default: true
      },
      ...itemProps // 基础属性
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      /*
       value,
       run,
       clear,
       myinput
      */
      
      return {
        ...itemController(props, context.emit) // value、mySubmit
      }
    }
  })
</script>
